let apiRoot = '${API_URL}';
if (window.location.hostname === 'localhost') {
  // apiRoot = 'https://api.favuniglobal.com/';
} 

export const baseUrl = apiRoot;
